import apiClient, { unwrap } from './client';
import { setAccessToken, clearAccessToken } from './tokenStore';
import type {
  LoginCredentials,
  LoginResponse,
  AuthUser,
  ApiEnvelope,
} from '@types';

export const authApi = {
  /**
   * Exchange credentials for an access token (held in memory) + user. The
   * refresh token is set by the server as an httpOnly cookie (F1.2) — it never
   * appears in this response body and JS never reads it.
   */
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const envelope = await apiClient.post<ApiEnvelope<LoginResponse>>(
      '/v1/auth/login',
      credentials
    );
    const data = unwrap(envelope);
    setAccessToken(data.access_token);
    return data;
  },

  /** Current authenticated user. */
  getCurrentUser: async (): Promise<AuthUser> => {
    const envelope = await apiClient.get<ApiEnvelope<AuthUser>>('/v1/auth/me');
    return unwrap(envelope);
  },

  /** Revoke the refresh-token family server-side and drop the in-memory token. */
  logout: async (): Promise<void> => {
    try {
      await apiClient.post('/v1/auth/logout');
    } finally {
      clearAccessToken();
    }
  },
};

export default authApi;
